var symphony = symphony || {};

;
(function () {

	symphony.handlebarsHelpers = function () {

		var chop = function (str) {
			if (!_.isString(str)) return '';
			var re = /^[-_.\W\s]+|[-_.\W\s]+$/g;
			return str.trim().replace(re, '');
		};

		var identity = function (val) {
			return val;
		};

		var changeCase = function (str, fn) {
			if (!_.isString(str)) return '';
			if (str.length === 1) {
				return str.toLowerCase();
			}

			str = chop(str).toLowerCase();
			if (typeof fn !== 'function') {
				fn = identity;
			}

			var re = /[-_.\W\s]+(\w|$)/g;
			return str.replace(re, function (_, ch) {
				return fn(ch);
			});
		};

		Handlebars.registerHelper('camelcase', function (str) {
			return changeCase(str, function (ch) {
				return ch.toUpperCase();
			});
		});

		Handlebars.registerHelper('roundedDistance', function (center) {
			if (center) {
				return Math.round(center.distance);
			} else {
				return 0;
			}
		});

		Handlebars.registerHelper('concatAddress', function (center) {
			return center.address1.split(' ').join('+')
		});

		Handlebars.registerHelper('lowercase', function (text) {
			if (text == null) {
				return false;
			} else {
				return text.toString().toLocaleLowerCase();
			}
		});

		Handlebars.registerHelper('requireHttp', function (url) {
			if (url === null) {
				return false;
			} else {
				var prefix = 'http://';
				var ssl_pre = 'https://';
				if (url.substr(0, prefix.length) !== prefix && url.substr(0, ssl_pre.length) !== ssl_pre) {
					return url = prefix + url;
				} else {
					return url;
				}
			}
		});

		Handlebars.registerHelper("compare", function (lvalue, operator, rvalue, options) {
			var operators = {
				'==': function (l, r) {
					return l == r;
				},
				'===': function (l, r) {
					return l === r;
				},
				'!=': function (l, r) {
					return l != r;
				},
				'<': function (l, r) {
					return l < r;
				},
				'>': function (l, r) {
					return l > r;
				},
				'<=': function (l, r) {
					return l <= r;
				},
				'>=': function (l, r) {
					return l >= r;
				},
				'typeof': function (l, r) {
					return typeof l == r;
				},
				'&&': function (l, r) {
					return l && r;
				},
				'||': function (l, r) {
					return l || r;
				}
			}


			if (arguments.length < 3) {
				throw new Error("Handlerbars Helper 'compare' needs 2 parameters");
			}

			if (!operators[operator]) {
				throw new Error("Handlerbars Helper 'compare' doesn't know the operator " + operator);
			}

			return operators[operator](lvalue, rvalue);
		});

		Handlebars.registerHelper("capitalizeFirst", function (str) {
			if (str && typeof str === "string") {
				return str.charAt(0).toUpperCase() + str.slice(1);
			}
		});

		Handlebars.registerHelper('trim', function (text) {
			var maxLength = 200;
			var options;
			if (text.length <= maxLength) {
				return text;
			}
			if (!options) options = {};
			var defaultOptions = {
				// By default we add an ellipsis at the end
				suffix: true,
				suffixString: "...</p>",
				// By default we preserve word boundaries
				preserveWordBoundaries: true,
				wordSeparator: " "
			};
			$.extend(options, defaultOptions);
			// Compute suffix to use (eventually add an ellipsis)
			var suffix = "";
			if (text.length > maxLength && options.suffix) {
				suffix = options.suffixString;
			}

			// Compute the index at which we have to cut the text
			var maxTextLength = maxLength - suffix.length;
			var cutIndex;
			if (options.preserveWordBoundaries) {
				// We use +1 because the extra char is either a space or will be cut anyway
				// This permits to avoid removing an extra word when there's a space at the maxTextLength index
				var lastWordSeparatorIndex = text.lastIndexOf(options.wordSeparator, maxTextLength + 1);
				// We include 0 because if have a "very long first word" (size > maxLength), we still don't want to cut it
				// But just display "...". But in this case the user should probably use preserveWordBoundaries:false...
				cutIndex = lastWordSeparatorIndex > 0 ? lastWordSeparatorIndex : maxTextLength;
			} else {
				cutIndex = maxTextLength;
			}

			var newText = text.substr(0, cutIndex);
			return newText + suffix;
		});

		Handlebars.registerHelper('groupsServed', function (serviceType) {

			var groupsServed = [];

			if (_.findIndex(serviceType, function (o) {
					return o.men === true;
				}) >= 0) {
				groupsServed.push(' Men');
			}

			if (_.findIndex(serviceType, function (o) {
					return o.women === true;
				}) >= 0) {
				groupsServed.push(' Women');
			}

			if (_.findIndex(serviceType, function (o) {
					return o.limitByAge === false && o.startAge <= 18;
				}) >= 0) {
				groupsServed.push(' Children');
			}

			if (_.findIndex(serviceType, function (o) {
					return o.families === true;
				}) >= 0) {
				groupsServed.push(' Families');
			}

			return groupsServed;
		});

		Handlebars.registerHelper('availableServices', function (serviceTypes) {

			var serviceList = [];
			_(serviceTypes).forEach(function (type) {

				_(type.serviceDetails).forEach(function (detail) {
					serviceList.push(' ' + detail.name);
				});

			});

			return serviceList;

		});

		Handlebars.registerHelper('formatDate', function (date, format) {
			if (siteLanguage != 'en') {
				var localLocale = moment.utc(date).local();			
				moment.locale(siteLanguage);
				localLocale.locale(false);
				return localLocale.format(format);
			}
			return moment.utc(date).local().format(format);
		});

		Handlebars.registerHelper("concat", function (str1, str2) {
			if (str1 && typeof str1 === "string" && str2 && typeof str2 === "string") {
				return str1 + str2;
			}
		});

		Handlebars.registerHelper("absoluteUrl", function (path) {
			if (path && typeof path === "string") {
				return '/' + siteUrlAlias + path;
			}
		});

		Handlebars.registerHelper("rowstart", function (idx, rowlength) {
			return (idx % rowlength == 0);
		});

		Handlebars.registerHelper("rowend", function (idx, rowlength) {
			return (idx % rowlength == (rowlength - 1));
		});

		Handlebars.registerHelper('paginate', function (pagination, options) {
			var type = options.hash.type || 'middle';
			var ret = '';
			var pageCount = Number(pagination.pageCount);
			var page = Number(pagination.page);
			var limit;
			if (options.hash.limit) limit = +options.hash.limit;

			//page pageCount
			var newContext = {};
			switch (type) {
				case 'middle':
					if (typeof limit === 'number') {
						var i = 0;
						var leftCount = Math.ceil(limit / 2) - 1;
						var rightCount = limit - leftCount - 1;
						if (page + rightCount > pageCount)
							leftCount = limit - (pageCount - page) - 1;
						if (page - leftCount < 1)
							leftCount = page - 1;
						var start = page - leftCount;

						while (i < limit && i < pageCount) {
							newContext = {
								n: start
							};
							if (start === page) newContext.active = true;
							ret = ret + options.fn(newContext);
							start++;
							i++;
						}
					} else {
						for (var i = 1; i <= pageCount; i++) {
							newContext = {
								n: i
							};
							if (i === page) newContext.active = true;
							ret = ret + options.fn(newContext);
						}
					}
					break;
				case 'previous':
					if (page === 1) {
						newContext = {
							disabled: true,
							n: 1
						}
					} else {
						newContext = {
							n: page - 1
						}
					}
					ret = ret + options.fn(newContext);
					break;
				case 'next':
					newContext = {};
					if (page === pageCount) {
						newContext = {
							disabled: true,
							n: pageCount
						}
					} else {
						newContext = {
							n: page + 1
						}
					}
					ret = ret + options.fn(newContext);
					break;
				case 'first':
					if (page === 1) {
						newContext = {
							disabled: true,
							n: 1
						}
					} else {
						newContext = {
							n: 1
						}
					}
					ret = ret + options.fn(newContext);
					break;
				case 'last':
					if (page === pageCount) {
						newContext = {
							disabled: true,
							n: pageCount
						}
					} else {
						newContext = {
							n: pageCount
						}
					}
					ret = ret + options.fn(newContext);
					break;
			}

			return ret;
		});

		Handlebars.registerHelper("unescapeHtml", function (value) {
			return $('<div />').html(value).text();
		});

		Handlebars.registerHelper("getAllowHtml", function (value) {
			return conductorSites.getAllowHtml(value);
		});

		Handlebars.registerHelper("getUseGetHelp", function (value) {
			return conductorSites.getUseGetHelp(value);
		});
		Handlebars.registerHelper("getAllowWordpressFeed", function (value) {
			return conductorSites.getAllowWordpressFeed(value);
		});
		Handlebars.registerHelper("getDhqConductorCount", function (value) {
			return conductorSites.getDhqConductorCount(value);
		});
		Handlebars.registerHelper("getDivisionId", function (value) {
			return conductorSites.getDivisionId(value);
		});
		Handlebars.registerHelper('contains', function (needle, haystack, options) {
			needle = Handlebars.escapeExpression(needle);
			haystack = Handlebars.escapeExpression(haystack);
			return (haystack.indexOf(needle) > -1) ? options.fn(this) : options.inverse(this);
		});
		Handlebars.registerHelper('startsWith', function (needle, haystack, options) {
			needle = Handlebars.escapeExpression(needle);
			haystack = Handlebars.escapeExpression(haystack);
			return (haystack.indexOf(needle) === 0) ? options.fn(this) : options.inverse(this);
		});
		Handlebars.registerHelper('typeOf', function (value) {
			return typeof value;
		});
		Handlebars.registerHelper('bool', function (value) {
			if (value) {
				return true;
			}
			return false;
		});
		Handlebars.registerHelper('getDate', function () {
			return Date.now();
		});

		Handlebars.registerHelper('formatPrice', function (price) {
			price = price.toString();
			if (price.indexOf('.') != -1 && price.split('.')[1].length == 1) {
				price += '0';
			}
            return price;
		});

		Handlebars.registerHelper('getSymphonyString', function (value) {
			return symphony.strings[value];
		});

		Handlebars.registerHelper("cleanText", function (value) {
			return value.replace(/’/g, "'").replace(/“/g, '"').replace(/”/g, '"');
		});
	};


})();
